import { EntityDisplay, EntitySlugs } from '@app/shell/menu/menu.component';

export const isMenuItemMatchingCurrentRoute = (
  entity: EntityDisplay | null,
  routeSlugs: EntitySlugs | null,
): boolean => {
  if (entity && routeSlugs) {
    return (
      entity.levelSlug === routeSlugs.levelSlug &&
      (!entity.moduleSlug || entity.moduleSlug === routeSlugs.moduleSlug) &&
      (!entity.stepSlugs || (!!routeSlugs.stepSlugs && entity.stepSlugs.includes(routeSlugs.stepSlugs[0])))
    );
  }

  return false;
};
